<template>
<div class="investmentExperience">
  <div class="card">
    <div class="title">{{$t('User.investExp')}}</div>
    <el-form
      ref="form"
      :model="secondForm"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="30">
        <el-col :lg="12" :md="12">
          <el-form-item
            prop="worlSta"
            :label="$t('User.worlSta')"
          >
            <el-select
              style="width: 100%"
              v-model="secondForm.worlSta"
              :placeholder="$t('please_choose')"
            >
              <el-option
                v-for="item in workList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12">
          <el-form-item
            prop="industry"
            :label="$t('User.industry')"
          >
            <el-select
              style="width: 100%"
              v-model="secondForm.industry"
              :placeholder="$t('please_choose')"
            >
              <el-option
                v-for="item in industryList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12">
          <el-form-item
            prop="income"
            :label="$t('User.income')"
          >
            <el-select
              style="width: 100%"
              class="worlSta"
              v-model="secondForm.income"
              :placeholder="$t('please_choose')"
            >
              <el-option
                v-for="item in incomeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12">
          <el-form-item
            style="width: 100%"
            prop="Assets"
            :label="$t('User.netAsset')"
          >
            <el-select
              style="width: 100%"
              v-model="secondForm.Assets"
              :placeholder="$t('please_choose')"
            >
              <el-option
                v-for="item in assetsList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12">
          <el-form-item
            prop="runAssets"
            :label="$t('User.curAsset')"
          >
            <el-select
              style="width: 100%"
              v-model="secondForm.runAssets"
              :placeholder="$t('please_choose')"
            >
              <el-option
                v-for="item in assetsList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12">
          <el-form-item
            style="width: 100%"
            prop="fundsSource"
            :label="$t('User.fundsSource')"
          >
            <el-checkbox-group
              v-model="secondForm.fundsSource"
            >
              <el-checkbox
                v-for="city in fundsSourceList"
                :label="city.value"
                :key="city.value"
              >
                {{city.label}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12">
          <el-form-item
            prop="invTarget"
            :label="$t('User.invTargetIs')"
          >
            <el-checkbox-group v-model="secondForm.invTarget" >
              <el-checkbox
                v-for="city  in invTargetList"
                :label="city.value"
                :key="city.label"
              >
                {{city.label}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12">
          <el-form-item
            prop="hadFx"
            :label="$t('User.levHis')"
          >
            <el-radio v-model="secondForm.hadFx"  label="1">{{$t('root.yes')}}</el-radio>
            <el-radio v-model="secondForm.hadFx"  label="2">{{$t('root.no')}}</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <div class="btn-line">
    <el-button
      class="next-btn"
      @click="prevHandle"
      :disabled="submitting"
    >{{$t('root.upper')}}</el-button>
    <el-button type="primary" @click="nextHandle" :loading="submitting" :disabled="submitting">{{$t('root.next')}}</el-button>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { savePerfectInfoStep } from '@/api/userCenter.js';
import { workList } from '@/assets/codelist/workList';
import { industryList } from '@/assets/codelist/industryList';
import { incomeList } from '@/assets/codelist/incomeList';
import { assetsList } from '@/assets/codelist/assetsList';
import { fundsSourceList } from '@/assets/codelist/fundsSourceList';
import { invTargetList } from '@/assets/codelist/invTargetList';
export default {
  name: "investmentExperience",
  props: {
    allData: {
      type: Object,
      default(){
        return {};
      }
    },
  },
  data() {
    return {
      submitting: false,
      workList: [],
      industryList: [],
      incomeList: [],
      assetsList: [],
      fundsSourceList: [],
      invTargetList:[],
      /*改造 遗产,储蓄及投资,其他,工作收入"*/
      secondForm: {
        worlSta: '',  //  就业状况
        industry: '',  //  行业,
        income: '',  //   年收入，
        Assets: '',  // 净资产
        runAssets: '', // 流动资产
        fundsSource: [], //  准备用来做投资的资金来源,
        invTarget: [],
        hadFx: '',
      },
      rules: {
        worlSta: [
          { required: true, message: this.$t('User.worlStaNullMessage'), trigger: 'change' }
        ],  //  就业状况
        industry: [
          { required: true, message: this.$t('User.industryNullMessage'), trigger: 'change' }
        ],  //  行业,
        income: [
          { required: true, message: this.$t('User.incomeNullMessage'), trigger: 'change' }
        ],  //   年收入，
        Assets: [
          { required: true, message: this.$t('User.AssetsNullMessage'), trigger: 'change' }
        ],  // 净资产
        runAssets: [
          { required: true, message: this.$t('User.runAssetsNullMessage'), trigger: 'change' }
        ], // 流动资产
        fundsSource: [
          { type:'array', required: true, message: this.$t('User.fundsSourceNullMessage'), trigger: 'change' }
        ], //  准备用来做投资的资金来源
        invTarget: [
          { type:'array', required: true, message: this.$t('User.plsInputInvTarget'), trigger: 'change' }
        ], //
        hadFx: [
          { required: true, message: this.$t('please_choose'), trigger: 'change' }
        ]
      },
    }
  },
  watch: {
    allData:{
      handler(news, olds) {
        this.secondForm.worlSta = (news.empStatus && this.parseString(news.empStatus)) || '';
        this.secondForm.industry = news.industry || '';
        this.secondForm.income = (news.annualIncome && (news.annualIncome + '')) || '';
        this.secondForm.Assets = news.netAsset || '';
        this.secondForm.runAssets = news.curAsset || '';
        if(news.fundsSource){
          this.secondForm.fundsSource = news.fundsSource && news.fundsSource.split(',');
        }
        if(news.invTarget){
          this.secondForm.invTarget = news.invTarget && news.invTarget.split(',');
        }
        this.secondForm.hadFx = news.hadFx;
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.workList = workList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.industryList = industryList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.incomeList = incomeList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.assetsList = assetsList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.fundsSourceList = fundsSourceList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.invTargetList = invTargetList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
  },
  mounted(){
    this.$nextTick(() => {
      this.$refs.form.clearValidate(['fundsSource','invTarget'])
    })
  },
  methods: {
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(!!valid);
        });
      });
    },
    prevHandle(){
      if (this.submitting) return;
      this.$emit('prev-step', 4);
    },
    getParams(){
      let Parmas = {
        empStatus: this.secondForm.worlSta,
        industry: this.secondForm.industry,
        annualIncome: this.secondForm.income,
        netAsset: this.secondForm.Assets,
        curAsset: this.secondForm.runAssets,
        fundsSource: this.secondForm.fundsSource.join(','),
        invTarget: this.secondForm.invTarget.join(','),
        hadFx: this.secondForm.hadFx,
      };
      return Parmas;
    },
    nextHandle() {
      if (this.submitting) return;
      this.submitting = true;
      this.$refs.form.validate((valid) => {
        if(valid){

          savePerfectInfoStep({
            ...this.getParams(),
            profileProgress: 4,
            id: this.userInfo.id
          }).then((res) => {
            this.$emit('next-step', 4);
          }).catch(() => {
          }).finally(() => {
            this.submitting = false;
          });

        }else {
          this.submitting = false;
          // 滚动到第一个错误的表单项
          this.$nextTick(() => {
            const errorItem = this.$refs.form.$el.querySelector('.el-form-item.is-error');
            if (errorItem) {
              errorItem.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          });
          console.log('no-pass');
        }
      })

    },
    parseString(parmas){
      return parmas + '';
    }
  },
}
</script>

<style scoped>
.investmentExperience {
  .el-col {
    margin-bottom: 6px;
  }
  .btn-line {
    @media screen and (max-width: 768px) {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
